import React from "react"

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, errorInfo) {
    console.error("Alma ErrorBoundary caught:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
        return (
        <div style={{ padding: "2rem", textAlign: "center" }}>
          <p>Something went wrong loading this page.</p>
          <button onClick={() => window.location.reload()}>Reload</button>
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary